import React from 'react';
import { SendingStepProps } from '../types';

const SendingStep: React.FC<SendingStepProps> = ({ sendingEmail }) => {
  return (
    <div className="flex-1 mx-auto">
      {sendingEmail ? (
        <div className="items-center justify-center">
          <div className="flex flex-col items-center gap-2 p-4">
            <svg
              className="animate-spin h-6 w-6 text-gray-500"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              />
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              />
            </svg>
            <p className="text-gray-500 text-xs sm:text-sm text-center">
              Sending campaign emails, please wait...
            </p>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default SendingStep;
